/**
 * 公車路線幾何來源（前端，與 backend/utils/bus-geometry-source.js 同步）
 */
export const GEOMETRY_SOURCES = {
    TDX_SHAPE: 'TDX_SHAPE',
    OSM_RELATION: 'OSM_RELATION',
    OSM_WAY: 'OSM_WAY',
    TDX_STOP_CHAIN: 'TDX_STOP_CHAIN',
    HOOKY_MANUAL: 'HOOKY_MANUAL'
};

const GEOMETRY_SOURCE_LABELS = {
    TDX_SHAPE: '交通部 TDX 路線軌跡',
    OSM_RELATION: 'OpenStreetMap（路線關聯）',
    OSM_WAY: 'OpenStreetMap（道路線段拼接）',
    TDX_STOP_CHAIN: '依 TDX 站序站點連線（推算）',
    HOOKY_MANUAL: 'Hooky 後台人工繪製'
};

export function geometrySourceLabel(source) {
    return GEOMETRY_SOURCE_LABELS[source] || '未知幾何來源';
}

export function isDerivedGeometry(props = {}) {
    return props.h_shape_status === 'derived' || props.h_geometry_source === 'TDX_STOP_CHAIN';
}
